<template>
<ValidationObserver ref="observer">
  <form ref="add_service_master_form" @submit.prevent="addParkingLine">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          <span style="color:brown">Add Service Master</span>
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="category" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Category</label>
                <md-select v-model="parking_line_category" required>
                  <md-option value="1">A</md-option>
                  <md-option value="2">B</md-option>
                  <md-option value="3">C</md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.parking_line_category" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Name</label>
                <md-input v-model="parking_line_name" required />
                <validation-error :errors="apiValidationErrors.parking_line_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content>
      <br>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense"  @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);
// validasi pesan error required field
extend('name', {
  ...required,
  message: 'Parking Line Name field is required'
});
extend('category', {
  ...required,
  message: 'Parking Line Category field is required'
});
export default {
  name: "add-parking-line",

  props: {
    data: Object
  },

  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({
    parking_line_category: null,
    parking_line_name: null
  }),

  created() {
    this.onOpen();
  },
  methods: {
    // fungsi tombol direct ke list view table
    backtoList(id) {
      this.$router.replace({ name: 'List Parking Line', params: { id: id } })
    },
      
    async onOpen(){
      await this.$store.dispatch("workshop_parking_line/list")
      this.options_service_category = await this.$store.getters["workshop_parking_line/list"]
    },
    
    // validasi untuk add data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will Saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, saved it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addParkingLine()
        }
      });
    },

    // fungsi add data
    async addParkingLine() {
      const data = {
        type: "workshop_parking_lines",
        parking_line_category: this.parking_line_category,
        parking_line_name: this.parking_line_name
      }
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_parking_line/add", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // kembali ke list service master
        await this.$router.push({name: 'List Parking Line'});
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
        console.log(e.response.data.errors);
        this.setApiValidation(e.response.data.errors);
      }

    }
  }
};
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
